import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SecurityBusinessCta() {
  return;
}